/**
 * @fileoverview Title and name fields for one additional contact.
 */

import React from "react";
import Select from "react-select";
import { getSelectedOption, selectStyles } from "../../../utils/common";
import styles from "./ContactsData.module.css";

export const AdditionalContactIdentityFields = ({
  t,
  index,
  contact,
  titleOptions,
  form,
  getFieldValidationState,
  getErrorMessage,
}) => {
  const { selectedTitle, setSelectedTitle, handleInputChange } = form;

  return (
    <div className={styles.inputRow}>
      <div className={styles.inputGroup}>
        <label className={styles.inputLabel}>
          {t("components.contactsData.titleLabel")}
        </label>
        <Select
          value={getSelectedOption(titleOptions, selectedTitle)}
          onChange={(selectedOption) => {
            setSelectedTitle(selectedOption.value);
            handleInputChange("titulo", selectedOption.value);
          }}
          options={titleOptions}
          placeholder={t("components.contactsData.titlePlaceholder")}
          styles={selectStyles}
          className="select__control"
        />
        <p className={styles.notVisibleFieldMessage}>
          *{t("components.corporateIdentity.notVisibleFieldMessage")}
        </p>
      </div>
      <div className={styles.inputGroup}>
        <label className={styles.inputLabel}>
          {t("components.contactsData.nameLabel")}
        </label>
        <input
          type="text"
          className={`${styles.input} ${
            getFieldValidationState(index, "nombre", contact?.nombre || "") ===
            "error"
              ? styles.inputError
              : ""
          }`}
          placeholder={t("components.contactsData.namePlaceholder")}
          value={contact?.nombre || ""}
          onChange={(e) => handleInputChange("nombre", e.target.value)}
          maxLength={100}
        />
        {getErrorMessage(index, "nombre", contact?.nombre || "") && (
          <p className={styles.errorMessage}>
            {getErrorMessage(index, "nombre", contact?.nombre || "")}
          </p>
        )}
      </div>
      <div className={`${styles.inputGroup} ${styles.tabletBottomSpacing}`}>
        <label className={styles.inputLabel}>
          {t("components.contactsData.middleNameLabel")}
        </label>
        <input
          type="text"
          className={`${styles.input} ${
            getFieldValidationState(
              index,
              "segundoNombre",
              contact?.segundoNombre || "",
            ) === "error"
              ? styles.inputError
              : ""
          }`}
          placeholder={t("components.contactsData.middleNamePlaceholder")}
          value={contact?.segundoNombre || ""}
          onChange={(e) => handleInputChange("segundoNombre", e.target.value)}
          maxLength={100}
        />
        {getErrorMessage(
          index,
          "segundoNombre",
          contact?.segundoNombre || "",
        ) && (
          <p className={styles.errorMessage}>
            {getErrorMessage(index, "segundoNombre", contact?.segundoNombre || "")}
          </p>
        )}
      </div>
      <div className={styles.inputGroup}>
        <label className={styles.inputLabel}>
          {t("components.contactsData.fatherLastNameLabel")}
        </label>
        <input
          type="text"
          className={`${styles.input} ${
            getFieldValidationState(
              index,
              "apellidoPaterno",
              contact?.apellidoPaterno || "",
            ) === "error"
              ? styles.inputError
              : ""
          }`}
          placeholder={t("components.contactsData.fatherLastNamePlaceholder")}
          value={contact?.apellidoPaterno || ""}
          onChange={(e) =>
            handleInputChange("apellidoPaterno", e.target.value)
          }
          maxLength={100}
        />
        {getErrorMessage(
          index,
          "apellidoPaterno",
          contact?.apellidoPaterno || "",
        ) && (
          <p className={styles.errorMessage}>
            {getErrorMessage(
              index,
              "apellidoPaterno",
              contact?.apellidoPaterno || "",
            )}
          </p>
        )}
      </div>
    </div>
  );
};

export const AdditionalContactMotherLastNameField = ({
  t,
  index,
  contact,
  form,
  getFieldValidationState,
  getErrorMessage,
}) => {
  const { handleInputChange } = form;

  return (
    <div className={styles.inputGroup}>
      <label className={styles.inputLabel}>
        {t("components.contactsData.motherLastNameLabel")}
      </label>
      <input
        type="text"
        className={`${styles.input} ${
          getFieldValidationState(
            index,
            "apellidoMaterno",
            contact?.apellidoMaterno || "",
          ) === "error"
            ? styles.inputError
            : ""
        }`}
        placeholder={t("components.contactsData.motherLastNamePlaceholder")}
        value={contact?.apellidoMaterno || ""}
        onChange={(e) => handleInputChange("apellidoMaterno", e.target.value)}
        maxLength={100}
      />
      {getErrorMessage(
        index,
        "apellidoMaterno",
        contact?.apellidoMaterno || "",
      ) && (
        <p className={styles.errorMessage}>
          {getErrorMessage(
            index,
            "apellidoMaterno",
            contact?.apellidoMaterno || "",
          )}
        </p>
      )}
    </div>
  );
};
